// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"facebook-button-module--wrapper--yDn6z","link":"facebook-button-module--link--130Lj"};